import React from "react";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import Button from "@directv-digital/fusion.atoms.button";
import { CtaSectionProps } from "../package-carousel.props";
import { DtvTheme } from "@directv-digital/dds.ui.dtv-theme/dist/dtv-theme";
import { getAnalyticsAttrs } from "@directv-digital/dds.services.analytics-service";

const bps = DtvTheme.breakpoints;

const styles = {
  ctaStyles: {
    "&:before": {
      border: "0px solid transparent !important"
    },
    width: {
      xs: "100%",
      sm: "287px",
      md: "335px"
    },
    margin: "0",
    [bps.down(bps.values.sm)]: {
      width: "100% !important"
    },
    [bps.up(bps.values.sm)]: {
      width: "287px !important"
    },
    [bps.up(bps.values.md)]: {
      width: "335px !important"
    },
    "& span": {
      fontFamily: "roboto-medium"
    }
  }
};

const CtaSection = (props: CtaSectionProps) => {
  const { cta, secondaryCta } = props;
  try {
    return (
      <>
        {cta?.label && (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          <Button
            aria-label={cta?.label}
            buttontype={cta?.buttontype || "primary"}
            googleanalyticsdata={getAnalyticsAttrs(cta?.label, "genrepack_carousel", cta?.targeturl)}
            href={cta?.targeturl}
            mode={cta?.mode || "light"}
            size={cta?.size || "large"}
            tabIndex={0}
            sx={{
              color: cta?.color,
              background: cta?.background,
              "&:hover, &:active, &:focus": {
                color: cta?.hover?.color,
                background: cta?.hover?.background,
                border: cta?.hover?.border
              },
              ...styles.ctaStyles
            }}
            {...cta}
          >
            {cta?.label}
          </Button>
        )}
        {secondaryCta?.label && (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          <Button
            aria-label={secondaryCta?.label}
            buttontype={secondaryCta?.buttontype || "secondary"}
            googleanalyticsdata={getAnalyticsAttrs(secondaryCta?.label, "genrepack_carousel", secondaryCta?.targeturl || secondaryCta?.modalData?.url)}
            mode={secondaryCta?.mode || "light"}
            size={secondaryCta?.size || "large"}
            tabIndex={0}
            sx={{
              color: secondaryCta?.color,
              background: secondaryCta?.background,
              border: secondaryCta?.border,
              "&:hover, &:active, &:focus": {
                color: secondaryCta?.hover?.color,
                background: secondaryCta?.hover?.background,
                border: secondaryCta?.hover?.border
              },
              ...styles.ctaStyles
            }}
            {...secondaryCta}
            {...(secondaryCta?.modalData?.url ?
              {
                  modalData: { url: secondaryCta?.modalData?.url },
                  modalType: secondaryCta?.modalType || "iframe"
                } :
              { targeturl: secondaryCta?.targeturl })}
          >{secondaryCta?.label}</Button>)}
      </>
    );
  } catch (error) {
    return <ErrorDisplay component="CtaSection" error={error} />;
  }
};

export default React.memo(CtaSection);
